var mp = mp || {};

// Slider - Hero
//-----------------------------------------------------------------
mp.sliderHomeFold = function() {
    var $slider = $('.home_fold__slider .slider');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        arrows: true,
        dots: false,
        speed: 1600,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        appendArrows: '.home_fold__slider .arrows',
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
    });
}


// Slider - References
//-----------------------------------------------------------------
mp.sliderReferences = function() {
    var $slider = $('.references__slider');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        arrows: false,
        dots: true,
        speed: 800,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }
          ]
    });
}



// Slider - Services
//-----------------------------------------------------------------
mp.sliderServices = function() {
    var $slider = $('.services__slider');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        arrows: false,
        dots: false,
        speed: 800,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        autoplay: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    dots: true,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
          ]
    });
}


$(document).ready(function (){
    mp.sliderHomeFold();
    mp.sliderReferences();
    mp.sliderServices();
});